import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

/**
 * Animated 3-light traffic signal motif. Cycles red → amber → green on a 4s loop
 * to reinforce "vehicles obeying signals". Under reduced-motion it rests on green
 * (the positive, on-brand state) with the others dimmed.
 *
 * @param {object} props
 * @param {number} [props.size=64]
 */
export default function TrafficSignal({ size = 64, className }) {
    const reduce = useReducedMotion();

    // Each light's brightness keyframes across one 4s cycle.
    const lights = [
        { color: 'hsl(var(--destructive))', on: reduce ? 0.25 : [1, 1, 0.2, 0.2, 0.2, 1], cy: 16 },
        { color: 'hsl(var(--warning))', on: reduce ? 0.25 : [0.2, 0.2, 1, 0.2, 0.2, 0.2], cy: 32 },
        { color: 'hsl(var(--success))', on: reduce ? 1 : [0.2, 0.2, 0.2, 1, 1, 0.2], cy: 48 },
    ];
    const times = [0, 0.42, 0.5, 0.58, 0.95, 1];

    return (
        <svg
            width={size}
            height={size * 1.5}
            viewBox="0 0 64 96"
            className={className}
            role="img"
            aria-label="Traffic signal cycling through red, amber and green"
        >
            <rect x="18" y="4" width="28" height="88" rx="10" fill="hsl(222 47% 11%)" />
            {lights.map((l, i) => (
                <motion.circle
                    key={i}
                    cx="32"
                    cy={l.cy}
                    r="9"
                    fill={l.color}
                    initial={{ opacity: Array.isArray(l.on) ? l.on[0] : l.on }}
                    animate={{ opacity: l.on }}
                    transition={
                        Array.isArray(l.on)
                            ? { duration: 4, times, repeat: Infinity, ease: 'linear' }
                            : undefined
                    }
                />
            ))}
        </svg>
    );
}
